import { createScopedReducer } from '@mews-commander/utils';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import NewReservationScreenStep from '../enums/NewReservationScreenStep';
import {
    STEP_CHANGED,
    RESOURCE_CATEGORY_TYPE_SELECTED,
    CREATE_RESERVATION_GROUP_STARTED,
    CREATE_RESERVATION_GROUP_SUCCEEDED,
    CREATE_RESERVATION_GROUP_FAILED,
    SERVICE_SELECTED,
    RESERVATION_PLACE_SELECTED,
    SERVICE_CHANGE_STARTED,
    SERVICE_CHANGE_CONFIRMED,
    SERVICE_CHANGE_CANCELLED,
    RESERVATION_PLACE_CHANGE_STARTED,
    RESERVATION_PLACE_CHANGE_CONFIRMED,
    RESERVATION_PLACE_CHANGE_CANCELLED,
    CONFIRMATION_SHOWN,
    RESET_SCREEN,
    TAX_ENVIRONMENT_SET,
    AVAILABILITY_BLOCK_SELECTED,
    FILTERS_CHANGED,
    SHOW_CHANGE_DATE_DIALOG,
    HIDE_CHANGE_DATE_DIALOG,
    SHOW_CHANGE_SERVICE_DIALOG,
    HIDE_CHANGE_SERVICE_DIALOG,
    SCREEN_SERVICE_CHANGED,
} from '../actions/types';

export const FILTER_DEFAULT_VALUES = {
    selectedResourceId: null,
    selectedFloorNumbers: [],
};

export const INITIAL_STATE = {
    currentStep: NewReservationScreenStep.Dates,
    filterValues: FILTER_DEFAULT_VALUES,
    showChangeDateDialog: false,
    showChangeServiceDialog: false,
    ...META_STATE_SUCCEEDED,
};

export default createScopedReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [STEP_CHANGED]: (state, step) => ({
        ...state,
        previousStep: state.currentStep,
        currentStep: step,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESOURCE_CATEGORY_TYPE_SELECTED]: (state, { resourceCategoryType }: $TSFixMe) => ({
        ...state,
        resourceCategoryType,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SERVICE_SELECTED]: (state, serviceId) => ({
        ...state,
        serviceId,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESERVATION_PLACE_SELECTED]: (state, reservationPlaceId) => ({
        ...state,
        reservationPlaceId,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RESERVATION_PLACE_CHANGE_STARTED]: (state, reservationPlaceId) => ({
        ...state,
        nextReservationPlaceId: reservationPlaceId,
    }),

    [RESERVATION_PLACE_CHANGE_CONFIRMED]: (state: $TSFixMe) => ({
        ...state,
        nextReservationPlaceId: null,
    }),

    [RESERVATION_PLACE_CHANGE_CANCELLED]: (state: $TSFixMe) => ({
        ...state,
        nextReservationPlaceId: null,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SERVICE_CHANGE_STARTED]: (state, serviceId) => ({
        ...state,
        nextServiceId: serviceId,
    }),

    [SERVICE_CHANGE_CONFIRMED]: (state: $TSFixMe) => ({
        ...state,
        nextServiceId: null,
    }),

    [SERVICE_CHANGE_CANCELLED]: (state: $TSFixMe) => ({
        ...state,
        nextServiceId: null,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [CONFIRMATION_SHOWN]: (state, { url }: $TSFixMe) => ({
        ...state,
        reservationGroupUrl: url,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [TAX_ENVIRONMENT_SET]: (state, isMultiTaxEnvironment) => ({
        ...state,
        isMultiTaxEnvironment,
    }),

    [RESET_SCREEN]: ({ cityId, serviceId, resourceCategoryType }: $TSFixMe) => ({
        cityId,
        serviceId,
        resourceCategoryType,
        currentStep: NewReservationScreenStep.Dates,
        ...META_STATE_SUCCEEDED,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [AVAILABILITY_BLOCK_SELECTED]: (state, availabilityBlockId) => ({
        ...state,
        availabilityBlockId,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [FILTERS_CHANGED]: (state, values) => ({
        ...state,

        filterValues: {
            ...state.filterValues,
            ...values,
        },
    }),
    [SHOW_CHANGE_DATE_DIALOG]: (state: $TSFixMe) => ({
        ...state,
        showChangeDateDialog: true,
    }),

    [HIDE_CHANGE_DATE_DIALOG]: (state: $TSFixMe) => ({
        ...state,
        showChangeDateDialog: false,
    }),

    [SHOW_CHANGE_SERVICE_DIALOG]: (state: $TSFixMe) => ({
        ...state,
        showChangeServiceDialog: true,
    }),

    [HIDE_CHANGE_SERVICE_DIALOG]: (state: $TSFixMe) => ({
        ...state,
        showChangeServiceDialog: false,
    }),

    [SCREEN_SERVICE_CHANGED]: (state: $TSFixMe) => ({
        ...state,
        serviceId: undefined,
    }),

    ...createEntityAsyncMetaHandlers({
        STARTED: CREATE_RESERVATION_GROUP_STARTED,
        SUCCEEDED: CREATE_RESERVATION_GROUP_SUCCEEDED,
        FAILED: CREATE_RESERVATION_GROUP_FAILED,
    }),
});
